import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
  AiOutlineMail,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I'm a CS undergrad at <b className="purple">Scaler School of Technology</b> and <b className="purple">BITS Pilani</b>, passionate about building intelligent systems and scalable applications.
              <br />
              <br />
              Alongside building, I do <b className="purple">AI safety research</b>. My{" "}
              <a href="https://arxiv.org/abs/2608.27167" target="_blank" rel="noreferrer" className="purple" style={{ textDecoration: "underline" }}>
                sole-author paper
              </a>{" "}
              shows that AI agents shown official-looking data will confidently answer questions nobody can know, even when every number is fake.
              <br />
              <br />I am fluent in
              <i>
                <b className="purple"> Java, JavaScript, Python, Go, and Dart. </b>
              </i>
              <br />
              <br />
              My fields of interest are building &nbsp;
              <i>
                <b className="purple">AI-Powered Applications</b> using{" "}
                <b className="purple">
                  RAG, Vector Embeddings, and Multi-LLM Architectures
                </b>
              </i>
              <br />
              <br />
              I specialize in full-stack development with
              <b className="purple"> Node.js, React, React Native, Next.js</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern AI Technologies
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> OpenAI API, Pinecone, and Deepgram</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  aria-label="GitHub"
                  href="https://github.com/Pranav-1100"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  aria-label="X (Twitter)"
                  href="https://x.com/pranavbuilds_"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  aria-label="LinkedIn"
                  href="https://www.linkedin.com/in/pranav-aggarwal-474554231/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  aria-label="Instagram"
                  href="https://www.instagram.com/itspranav_____/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
              <li className="social-icons">
                <a
                  aria-label="Email"
                  href="mailto:pranavaggarwal1100@gmail.com"
                  className="icon-colour home-social-icons"
                >
                  <AiOutlineMail />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
